import { useRef, useState, useEffect } from "react";
import { FaBars, FaTimes, FaSignOutAlt } from "react-icons/fa";
import { FaFileAlt, FaHistory, FaUsers, FaUser, FaBook, FaTelegram, FaRobot } from "react-icons/fa";
import { GrDocumentConfig } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { IoPersonAddSharp } from "react-icons/io5";
import { FaTasks } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { LuFileScan } from "react-icons/lu";
import { useAuth } from "../auth/Auth";
import axios from 'axios';
import "../header/Header.css";

function Header() {
    const navRef = useRef();
    const { user, logout } = useAuth();
    const isLoggedIn = localStorage.getItem('refreshToken');
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [menuOpen, setMenuOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [generalError, setGeneralError] = useState("");

    useEffect(() => {
        const interceptor = axios.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response && error.response.status === 401) {
                    logout();
                    navigate('/Login');
                }
                return Promise.reject(error);
            }
        );

        const fetchUsername = async () => {
            if (user?.user_id) {
                try {
                    const userId = user.user_id;
                    const usernameResponse = await axios.get(`https://hub2.daolog.net/current-user/${userId}`);
                    setUsername(`<b>${usernameResponse.data.username}</b>`);
                } catch (err) {
                    console.error('Error fetching data:', err);
                    if (err.response && err.response.status === 401) {
                        logout();
                        navigate('/Login');
                    }
                    setGeneralError('Користувач не авторизований');
                }
            }
            setLoading(false);
        };
        
        fetchUsername();
        
        return () => {
            axios.interceptors.response.eject(interceptor);
        };
    }, [user, navigate, logout]);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleLogout = () => {
        logout();
        setUsername("");
        navigate('/Login');
    };

    if (loading) {
        return <div>Loading...</div>;
    }
  
    if (generalError) {
        return <div>{generalError}</div>;
    }

    return (
        <>
            <header className={`responsive-header ${menuOpen ? "menu-open" : ""}`}>
                <div className="header-container">
                
                    <button className="menu-toggle" onClick={toggleMenu}>
                        {menuOpen ? <FaTimes /> : <FaBars />}
                    </button>
                    <nav className={`main-nav ${menuOpen ? "active" : ""}`} ref={navRef}>
                        {isLoggedIn ? (
                            <ul className="nav-links">
                               
                                
                                <li>
                                    <a href="/RestForm">
                                        <IoPersonAddSharp className="nav-icon" />
                                        <span>Операції</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="/Directory">
                                        <FaBook className="nav-icon" />
                                        <span>Довідник</span>
                                    </a>
                                </li>
                              
                                <li>
                                    <a href="/SuppliersPagePl">
                                        <FaBook className="nav-icon" />
                                        <span>Аки в тг</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="/IntallSyrveAll">
                                        <FaBook className="nav-icon" />
                                        <span>InstallOffice/Chain</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="/InstallSyrveFrontAll">
                                        <FaBook className="nav-icon" />
                                        <span>InstallFront</span>
                                    </a>
                                </li>
                              
                            
                              
                                {/* <li>
                                    <a href="/UserConfig">
                                        <GrDocumentConfig className="nav-icon" />
                                        <span>Конфіги</span>
                                    </a>
                                </li> */}
                                <li>
                                    <a href="/UserManagement">
                                        <GrDocumentConfig className="nav-icon" />
                                        <span>Перегляд та видалення користувачів</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="/Equip">
                                        <GrDocumentConfig className="nav-icon" />
                                        <span>Обладнання</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" onClick={handleLogout}>
                                        <FaSignOutAlt className="nav-icon" />
                                        <span>Вихід</span>
                                    </a>
                                </li>
                            </ul>
                        ) : (
                            <a href="/Login" className="login-link">Login</a>
                        )}
                    </nav>
                </div>
                <div className="user-info">
                    <div className="username" dangerouslySetInnerHTML={{__html: username}}></div>
                </div>
            </header>
            <div className="top-bar">
                <div className="top-bar-content">
                    <div className="phone-number">тел. 0 67 333 98 80 (07:00 - 01:00)</div>
                    <div className="top-bar-buttons">
                        <a href="https://t.me/SyrveSupport_dao_chatmanager" target="_blank" rel="noopener noreferrer" className="top-bar-btn telegram-btn">
                            <FaTelegram className="btn-icon" />
                        </a>
                    </div>
                </div>
            </div>
            <div className="content-spacer"></div>
        </>
    );
}

export default Header;